export default __webpack_public_path__ + "static/media/breast.4cc28fa2.svg";